import { SystemMaintenanceEventsSearchResponse } from '@lio/api-types';
import { Forbidden } from '../../pages';

type MaintenanceProps = {
  activeEvent: SystemMaintenanceEventsSearchResponse['items'][0];
};

export const FallbackMaintenance = ({ activeEvent }: MaintenanceProps) => {
  const parsedItems = activeEvent && JSON.parse(activeEvent?.body);
  const subtitle = parsedItems?.blocks.map((item: any) => item.text);

  return (
    <Forbidden
      title={activeEvent?.title || ''}
      subtitle={subtitle}
      primaryBtnText={activeEvent?.linkDescription || undefined}
      primaryBtnRedirect={activeEvent?.link || undefined}
      isMaintenance
      fullScreen
    />
  );
};
